import * as React from 'react'
import { Component } from 'react'

class Redirect extends Component {

    render () {
        return (
            <div className="redirect">
                {/* <h1>404</h1>
                <h3>抱歉, 你访问的页面不存在</h3> */}
                <h3>数据加载中, 请等待</h3>
            </div>
        )
    }
}

export default Redirect